import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SITE_INSTAGRAM_USER } from '../../config/site';


const OnlyConditions = props => {
    const { t } = useTranslation( 'only_conditions' );
    const { language } = useSelector( store => store );

    return (
    <div className="tabs">
      <div className="switch_select_area only_conditions_area">
        <div>{ t("УСЛОВИЯ ИГРЫ") }</div>
      </div>
      <div className="tabs_container">
        <div className="tabs_conditions_container"></div>
        <div className="tabs_conditions">
          <div
            dangerouslySetInnerHTML={{
              __html: props.bloggerData.conditions
            }}
          ></div>
          {props.bloggerData.isSupportEnabled === 1 && props.bloggerData.showLink === 0 ? (
            <div className="support">
                { t("По всем вопросам обращайтесь сюда") }:{" "}
                {language === "ru" ?<a href={ `https://www.instagram.com/${SITE_INSTAGRAM_USER}/` } target="_blank" rel="noopener noreferrer">
                <span>@{ SITE_INSTAGRAM_USER }</span>
                </a> : <span onClick={() => window.MeTalk('openSupport')}>chat</span>}{" "}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default OnlyConditions;
